import type { FC } from 'react'
import Xarrow, { type xarrowPropsType as XarrowProps } from 'react-xarrows'

// partial from 'react-xarrows'
const defaultXarrowProps = {
  strokeWidth: 4,
  headSize: 6,
}

type OwnProps = {}

const ADDITIONAL_CLICKABLE_AREA_WIDTH = 8

// The visible line, as opposed to the wider transparent one that takes clicks.
export const ARROW_BODY_CLASS = 'Arrow-body'

const SmartArrow: FC<OwnProps & XarrowProps> = ({ ...xarrowProps }) => {
  const strokeWidth = xarrowProps.strokeWidth ?? defaultXarrowProps.strokeWidth
  const headSize = xarrowProps.headSize ?? defaultXarrowProps.headSize

  /* Чтобы кривые полностью наложились, необходимо, чтобы совпали размеры голов */
  /* Размер головы определяется произведением strokeWidth * headSize (неожиданно) */
  /* Поэтому именно произведения должны быть равны */

  const fatStrokeWidth = strokeWidth + ADDITIONAL_CLICKABLE_AREA_WIDTH

  return (
    <>
      <Xarrow
        {...xarrowProps}
        lineColor="transparent"
        headColor="transparent"
        dashness={false}
        strokeWidth={fatStrokeWidth}
        headSize={(headSize * strokeWidth) / fatStrokeWidth}
        labels={undefined}
      />
      <Xarrow
        {...xarrowProps}
        arrowBodyProps={{ className: ARROW_BODY_CLASS }}
      />
    </>
  )
}

export default SmartArrow
